import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PrivateRoute from './Utils/PrivateRoute';
import Store from "./Utils/Store";
import Main from "./Main";
import Home from "./Home";
import Trips from './Trips';
import Data from "./Data";

const App = () => {
  return (
    <Store>
      <Router>
        <Switch>
          <Route exact path="/" component={Main} />
          <PrivateRoute path="/home" component={Home} />
          <PrivateRoute path="/trips" component={Trips} />
          <PrivateRoute path="/data" component={Data} />
          <Route component={Main} />
        </Switch>
      </Router>
    </Store>
  );
}

export default App;